import PropTypes from 'prop-types'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import {
  CommunicationNote,
  MessageDot,
  MessageList,
  MessageRow,
  StyledContainer,
  UpdatedAt,
} from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/styled-components'
import CommunicationBoardEmptyState from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardEmptyState'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import IconCarbonNotification from '@/shared/icons/IconCarbonNotification'

// No fold toggle on purpose: the communications must stay in front of the agent.
const CommunicationBoardContent = ({ t, messages, updatedAt, error, folded = false }) => (
  <StyledContainer>
    <ModuleHeader highlighted>
      <ModuleHeading icon={IconCarbonNotification} moduleKey='communication-board' highlighted>
        {t('subscriptionForm:communication_board.title')}
      </ModuleHeading>
      <UpdatedAt hidden={!updatedAt}>{t('subscriptionTools:communication_board.last_updated', updatedAt)}</UpdatedAt>
    </ModuleHeader>

    <ModuleContent hidden={folded}>
      <SDNotification type='negative' hidden={!error} primaryText={error} />
      <CommunicationBoardEmptyState t={t} hidden={messages.length > 0 || !!error} />
      <MessageList $hidden={messages.length === 0 || !!error}>
        {messages.map(({ key, html }) => (
          <MessageRow key={key}>
            <MessageDot />
            <CommunicationNote dangerouslySetInnerHTML={{ __html: html }} />
          </MessageRow>
        ))}
      </MessageList>
    </ModuleContent>
  </StyledContainer>
)

CommunicationBoardContent.propTypes = {
  t: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, html: PropTypes.string })).isRequired,
  updatedAt: PropTypes.shape({ date: PropTypes.string, time: PropTypes.string }),
  error: PropTypes.string,
  folded: PropTypes.bool,
}

export default CommunicationBoardContent
